import { onUnmounted, ref } from 'vue'

export function useHealthCheck(intervalMs = 30000) {
  const isHealthy = ref(true)
  const isChecking = ref(false)

  const nuxtConfig = useRuntimeConfig()
  const baseUrl = nuxtConfig.public.gqlHost
  if (process.env.DISABLE_HEALTH_CHECK) {
    return {
      isHealthy,
      isChecking,
      checkHealth: () => null
    }
  }
  
  async function checkHealth() {
    try {
      isChecking.value = true
      const response = await fetch(`${baseUrl.replace('/graphql', '')}/health`)
      const data = await response.json()
      isHealthy.value = data.status === 'ok'
    } catch (error) {
      isHealthy.value = false
    } finally {
      isChecking.value = false
    }
  }

  // Initial check
  checkHealth()

  // Set up interval
  const intervalId = setInterval(checkHealth, intervalMs)

  // Clean up on component unmount
  onUnmounted(() => {
    clearInterval(intervalId)
  })

  return {
    isHealthy,
    isChecking,
    checkHealth,
  }
}
